import React from "react";

export default function PageContent({ children }) {
  return (
    <div className="avc-page">
      <div className="container">
        <div className="row">{children}</div>
      </div>
    </div>
  );
}
